import { GameCardData } from '@/features/games/internal/types/game-card-data';
import { useAppStore } from '@/features/shared/app-store';

const getRecency = (lastPlayedAt?: number) => lastPlayedAt ?? 0;

export const useAllGameCards = (): GameCardData[] => {
  const gameCards = useAppStore((s) => s.continueToPlayGameCards);

  return Object.values(gameCards)
    .sort((a, b) => getRecency(b.lastPlayedAt) - getRecency(a.lastPlayedAt))
    .map(({ ...card }) => card);
};
